import { cn } from '@/lib/utils';
import { FC, useState } from 'react';
import { InputContainer } from '../InputContainer';
import { InputProps, withField } from '../withField';
import { TextInputProps } from './TextInput';

interface ConfirmInputProps extends TextInputProps {
  target: string;
}

export const ConfirmInput: FC<InputProps<boolean> & ConfirmInputProps> = ({
  onChange,
  id,
  placeholder,
  target,
  suffix,
  prefix,
  autofocus
}) => {
  const [text, setText] = useState<string>();
  const onTextChange = (text: string) => {
    setText(text);
    onChange(text === target);
  };

  return (
    <InputContainer className={cn('px-3 py-2 focus-within:ring-red-500')}>
      {prefix && <span className="text-secondary-std mr-0.5 text-sm">{prefix}</span>}
      <input
        autoFocus={autofocus}
        value={text}
        onChange={e => onTextChange(e.target.value)}
        type="text"
        id={id}
        className="placeholder:text-secondary-std block flex-1 border-0 bg-transparent p-0 text-sm placeholder:opacity-60 focus:ring-0 sm:leading-6"
        placeholder={placeholder}
      />
      {suffix && <span className="text-secondary-std ml-0.5 text-sm">{suffix}</span>}
    </InputContainer>
  );
};

export const ConfirmField = withField<boolean, ConfirmInputProps>(ConfirmInput);
